import classnames from "classnames";
import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./genericSkeleton.module.scss";

function GenericSkeleton({ className }) {
  return (
    <div className={classnames(styles.container, className)}>
      <SkeletonTheme baseColor="#e6e6ed">
        <div className={styles.headlineTop}>
          <Skeleton
            containerClassName={classnames(styles.breadcrumbs, "mb-300")}
            count={3}
            height={20}
          />

          <div className={styles.user}>
            <Skeleton className="mr-50" circle width={48} height={48} />
            <p>
              <Skeleton count={2} width={150} />
            </p>
          </div>
        </div>

        <Skeleton className={classnames(styles.title, "mt-100 mb-100")} />

        <p className={styles.description}>
          <Skeleton count={2} />
        </p>
      </SkeletonTheme>
    </div>
  );
}

export default React.memo(GenericSkeleton);
